import { render, staticRenderFns } from "./ReferenceListValueDialog.vue?vue&type=template&id=00dc21e3"
import script from "./ReferenceListValueDialog.vue?vue&type=script&lang=js"
export * from "./ReferenceListValueDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports